// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__3wq4y","rowName":"styles_rowName__3H4Ce","twoColumns":"styles_twoColumns__10BP4"};